export interface ModuleDef {
  key: string;
  name: string;
  icon: string;
  desc: string;
  /** Always on, can't be switched off. */
  core?: boolean;
  /** Comes with every plan; nothing in the apps is gated on it, so it shows as Included, not as a switch. */
  included?: boolean;
  /** Other installed_modules keys this tile switches together with its own. */
  also?: readonly string[];
}

// The Owner Modules page, in canvas order (v2-o-modules). Keys are core.businesses.installed_modules
// values; the Guest Portal tile is drawn by the page itself because it is stored per store (the tile switches every store).
export const MODULE_CATALOG: ModuleDef[] = [
  { key: "pos", name: "Point of Sale", icon: "point_of_sale", core: true, desc: "Register, checkout, receipts, offline" },
  { key: "payments", name: "Payments", icon: "credit_card", core: true, desc: "Cash, card and QR wallets" },
  { key: "reports", name: "Reports", icon: "bar_chart", core: true, desc: "Sales, margins, time of day" },
  { key: "inventory", name: "Stock", icon: "inventory_2", desc: "Counts, variants, transfers" },
  { key: "restaurant", name: "Restaurant", icon: "restaurant", desc: "Tables and kitchen display" },
  { key: "retail", name: "Retail", icon: "barcode_scanner", desc: "Barcode sales, returns, exchanges" },
  { key: "crm", name: "Loyalty", icon: "loyalty", desc: "Member cards, points, rewards" },
  // Appointments ("service") and the service menu ("catalog") are one switch.
  { key: "service", name: "Services", icon: "spa", also: ["catalog"], desc: "Bookings, clients, service terminal" },
  { key: "team", name: "Team", icon: "badge", included: true, desc: "Shifts, payroll, performance" },
  { key: "purchasing", name: "Purchasing", icon: "local_shipping", included: true, desc: "Suppliers and orders" },
  { key: "promotions", name: "Promotions", icon: "sell", included: true, desc: "Discounts at checkout" },
  { key: "multistore", name: "Multi-store", icon: "storefront", included: true, desc: "Rollups and catalog copy" },
];
